import { Injectable } from '@angular/core';
import {
	ApprovePaymentMutation,
	PaginationInput,
	PaymentOfJobType,
	PaymentsOfJobQuery,
	RejectPaymentMutation,
} from '@generated/graphql';
import { map, Observable } from 'rxjs';
import { Pagination, PaginationData } from '@shared/types/pagination.type';
import { PaymentOfJob } from '@modules/payment/models/payment-of-job.model';
import { paginationDataFactory } from '@shared/factories/pagination.factory';
import { paymentOfJobFactory } from '@modules/payment/factories/payment-of-job.factory';

@Injectable({
	providedIn: 'root',
})
export class PaymentOfJobApi {
	constructor(
		private readonly paymentsOfJobQuery: PaymentsOfJobQuery,
		private readonly approvePaymentMutation: ApprovePaymentMutation,
		private readonly rejectPaymentMutation: RejectPaymentMutation,
	) {}

	getPaymentsOfJob$(
		pagination: PaginationInput,
		searchText: string = '',
	): Observable<PaginationData<PaymentOfJob>> {
		return this.paymentsOfJobQuery
			.fetch(
				{
					pagination,
					searchText,
				},
				{
					fetchPolicy: 'no-cache',
				},
			)
			.pipe(
				map((res) =>
					res.data.paymentsOfJob
						? paginationDataFactory.create(
								res.data.paymentsOfJob as Pagination<PaymentOfJobType>,
								paymentOfJobFactory,
						  )
						: null,
				),
			);
	}

	approvePayment$(id: string): Observable<boolean> {
		return this.approvePaymentMutation
			.mutate({
				id,
			})
			.pipe(map((result) => result.data.approvePayment));
	}

	rejectPayment(id: string, reason = ''): Observable<boolean> {
		return this.rejectPaymentMutation
			.mutate({
				id,
				reason,
			})
			.pipe(map((result) => result.data.rejectPayment));
	}
}
